var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.965088,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#585858"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 1.66509,
    width: 22.6,
    height: 22.6,
    rx: 11.3,
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 13.5485,
    rx: 1.75,
    ry: 1.75,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 13.5485,
    rx: 1.75,
    ry: 1.75,
    stroke: "white",
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 9.54846C7.64052 9.54846 7.41667 9.77232 7.41667 10.0485C7.41667 10.3246 7.64052 10.5485 7.91667 10.5485V9.54846ZM12 8.79846C12.2761 8.79846 12.5 8.5746 12.5 8.29846C12.5 8.02232 12.2761 7.79846 12 7.79846V8.79846ZM17.75 12.3818C17.75 12.1057 17.5261 11.8818 17.25 11.8818C16.9739 11.8818 16.75 12.1057 16.75 12.3818H17.75ZM7.91667 10.5485C8.19281 10.5485 8.41667 10.3246 8.41667 10.0485C8.41667 9.77232 8.19281 9.54846 7.91667 9.54846V10.5485ZM7.91667 10.5485H9.08333V9.54846H7.91667V10.5485ZM9.08333 10.5485C10.0038 10.5485 10.75 9.80227 10.75 8.8818H9.75C9.75 9.24999 9.45152 9.54846 9.08333 9.54846V10.5485ZM10.75 8.8818C10.75 8.83577 10.7873 8.79846 10.8333 8.79846V7.79846C10.235 7.79846 9.75 8.28349 9.75 8.8818H10.75ZM10.8333 8.79846H12V7.79846H10.8333V8.79846ZM16.75 12.3818V16.4651H17.75V12.3818H16.75ZM16.75 16.4651C16.75 16.8333 16.4515 17.1318 16.0833 17.1318V18.1318C17.0038 18.1318 17.75 17.3856 17.75 16.4651H16.75ZM16.0833 17.1318H7.91667V18.1318H16.0833V17.1318ZM7.91667 17.1318C7.54848 17.1318 7.25 16.8333 7.25 16.4651H6.25C6.25 17.3856 6.99619 18.1318 7.91667 18.1318V17.1318ZM7.25 16.4651V11.2151H6.25V16.4651H7.25ZM7.25 11.2151C7.25 10.8469 7.54848 10.5485 7.91667 10.5485V9.54846C6.99619 9.54846 6.25 10.2947 6.25 11.2151H7.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 9.54846C7.64052 9.54846 7.41667 9.77232 7.41667 10.0485C7.41667 10.3246 7.64052 10.5485 7.91667 10.5485V9.54846ZM12 8.79846C12.2761 8.79846 12.5 8.5746 12.5 8.29846C12.5 8.02232 12.2761 7.79846 12 7.79846V8.79846ZM17.75 12.3818C17.75 12.1057 17.5261 11.8818 17.25 11.8818C16.9739 11.8818 16.75 12.1057 16.75 12.3818H17.75ZM7.91667 10.5485C8.19281 10.5485 8.41667 10.3246 8.41667 10.0485C8.41667 9.77232 8.19281 9.54846 7.91667 9.54846V10.5485ZM7.91667 10.5485H9.08333V9.54846H7.91667V10.5485ZM9.08333 10.5485C10.0038 10.5485 10.75 9.80227 10.75 8.8818H9.75C9.75 9.24999 9.45152 9.54846 9.08333 9.54846V10.5485ZM10.75 8.8818C10.75 8.83577 10.7873 8.79846 10.8333 8.79846V7.79846C10.235 7.79846 9.75 8.28349 9.75 8.8818H10.75ZM10.8333 8.79846H12V7.79846H10.8333V8.79846ZM16.75 12.3818V16.4651H17.75V12.3818H16.75ZM16.75 16.4651C16.75 16.8333 16.4515 17.1318 16.0833 17.1318V18.1318C17.0038 18.1318 17.75 17.3856 17.75 16.4651H16.75ZM16.0833 17.1318H7.91667V18.1318H16.0833V17.1318ZM7.91667 17.1318C7.54848 17.1318 7.25 16.8333 7.25 16.4651H6.25C6.25 17.3856 6.99619 18.1318 7.91667 18.1318V17.1318ZM7.25 16.4651V11.2151H6.25V16.4651H7.25ZM7.25 11.2151C7.25 10.8469 7.54848 10.5485 7.91667 10.5485V9.54846C6.99619 9.54846 6.25 10.2947 6.25 11.2151H7.25Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.46513H17.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.46513H17.25",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.71509V11.2151",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.71509V11.2151",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAvatar);
export default __webpack_public_path__ + "static/media/add-avatar.58fef5750cf2a06e9ce9026b3bda66b4.svg";
export { ForwardRef as ReactComponent };